export default {"src":"/_next/static/media/retail_axa.63a04a53.svg","height":90,"width":107,"blurWidth":0,"blurHeight":0};